module.exports = __webpack_public_path__ + "static/media/sorting.3617412a.gif";